// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../../pip-search/state/';

const updatePipSearchByType = (state, action) => action.searchByType;

export default (state = getDefaultState().searchByType, action) => {

    const actionTypes = {
        [actions.UPDATE_PIP_SEARCH_BY_TYPE]: updatePipSearchByType
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/shared/reducers/search-by-type.js